import React from 'react';

import { AccordionSection, AccordionSectionProps } from './AccordionSection';
export * from './AccordionSection';

import { useCurrentTheme } from 'app/shared/theme';
import { Box } from 'app/shared/components/atoms';

interface AccordionProps {
  sections: AccordionSectionProps[];
}

export const Accordion = ({ sections }: AccordionProps) => {
  const { colors } = useCurrentTheme();

  return (
    <Box
      pt={2}
      gap={2}
      flexDirection="column"
      alignItems="flex-start"
      alignContent="stretch"
      bt={colors.primary.black.light}
    >
      {sections.map((section) => (
        <AccordionSection key={section.title} {...section} />
      ))}
    </Box>
  );
};
